import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Megaphone, AlertTriangle } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { ComposerModal } from './ComposerModal';
import { Toaster } from 'sonner';
import { IdentityGate } from './IdentityGate';
import { useApp } from './store';
export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const {
    composerOpen,
    openComposer,
    closeComposer,
    config,
    hasIdentity,
    isBrowsingOnly
  } = useApp();
  const location = useLocation();
  const announcement = config.announcement;
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return <div className="min-h-screen bg-navy-50/60 flex selection:bg-gold-200 selection:text-navy-900" data-id="element-176" data-mp="1vmgh94l6rvz9">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} onCreatePost={openComposer} data-id="element-177" data-mp="1qndks8j9uy2w" />

      <div className="flex-1 min-w-0 flex flex-col" data-id="element-178" data-mp="3eoz0hn28gpbr">
        <TopBar onMenuClick={() => setSidebarOpen(true)} data-id="element-179" data-mp="3eqjr51lffo4c" />

        {announcement.enabled && announcement.message.trim() && <div role={announcement.tone === 'urgent' ? 'alert' : 'status'} className={`flex items-center gap-2.5 px-4 sm:px-6 py-2.5 text-sm font-medium ${announcement.tone === 'urgent' ? 'bg-red-600 text-white font-semibold' : announcement.tone === 'gold' ? 'bg-gold-500 text-navy-900' : 'bg-navy-600 text-white'}`} data-id="element-180" data-mp="3oltvhvzas7la">
            {announcement.tone === 'urgent' ? <span className="relative flex h-4 w-4 shrink-0 items-center justify-center" data-id="element-181" data-mp="34xui0ddcmmc6">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white/60" data-id="element-182" data-mp="39pmbowrsx86j" />
                <AlertTriangle className="relative w-4 h-4 shrink-0" data-id="element-183" data-mp="2d7ztuk1892p3" />
              </span> : <Megaphone className="w-4 h-4 shrink-0" data-id="element-184" data-mp="2h7qfk9bwcsmr" />}
            <span data-id="element-185" data-mp="3kjforpys54by">{announcement.message}</span>
          </div>}

        <main className="flex-1 px-4 sm:px-6 lg:px-8 py-6" data-id="element-186" data-mp="3khmgk68iqc1u">
          <div className="max-w-[1400px] mx-auto" data-id="element-187" data-mp="3fjkztrykeotj">
            <Outlet data-id="element-188" data-mp="3firwl0ytehg5" />
          </div>
        </main>
      </div>

      <ComposerModal open={composerOpen} onClose={closeComposer} data-id="element-189" data-mp="3u8z97025568x" />

      {/* First-visit, no-password identity picker (remembered per browser).
                Hidden while the visitor is "just browsing" read-only, and re-shown
                if they later try to post. */}
      {!hasIdentity && !isBrowsingOnly && <IdentityGate data-id="element-190" data-mp="2wnl0tx766l0g" />}
      <Toaster position="top-right" data-id="element-191" data-mp="2wo34hew5w1ie" />
    </div>;
}